import { render, staticRenderFns } from "./UppyUploader.vue?vue&type=template&id=7a7cc647"
import script from "./UppyUploader.vue?vue&type=script&lang=js"
export * from "./UppyUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports